// extracted by mini-css-extract-plugin
export default {"viewer":"Viewer_viewer__NsYXL","back":"Viewer_back__5xebK"};